import React from 'react';
import PixiScaledSprite from "./PixiScaledSprite"
import PixiScaledText from "./PixiScaledText"
import { Container } from '@pixi/react';
import { utils } from '../../utils'
import { gameStateManager } from '../../App';

class PixiGamePositionRibbon extends React.Component
{

  getMeepleSpriteByColourID( colourID )
  {
    return "./ui/Meeple Counter Filled - " + utils.capitalizeFirstLetter( colourID ) + ".png";
  }

  render()
  {
    let goldColour = '0xFFD700';
    let silverColour = '0xC0C0C0';
    let bronzeColour = '0xCD7F32';
    let runnersUpColour = '0xB33829';

    let ribbonColours = [ goldColour, silverColour, bronzeColour, runnersUpColour ];

    const {
      stageRenderData,
      positionIndex,
      x,
      y
    } = this.props;

    const stageHeight = stageRenderData.height;
    const stageHeightRef = gameStateManager.canvasRefHeight;

    return (

      <Container
        x={ x }
        y={ ( y / stageHeightRef ) * stageHeight }
      >
        <PixiScaledSprite
          imageSrc={ positionIndex < 3 ? "./ui/award-ribbon-top-3.png" : "./ui/award-ribbon.png" }
          stageRenderData={ stageRenderData }
          x={ 0 }
          y={ 0 }
          tint={ ribbonColours[ Math.min( positionIndex, 3 ) ] }
          width={ positionIndex < 3 ? 65 : 60 }
          height={ positionIndex < 3 ? 65 : 60 }
          anchor={ 0.5 }
          scale={ this.props.scale ?? 1 }
        />

        <PixiScaledText
          text={ ( positionIndex + 1 ).toString() }
          stageRenderData={ stageRenderData }
          x={ 0 }
          y={ -6 * ( this.props.scale ?? 1 ) }
          anchor={ 0.5 }
          fontSize={ 25 * stageRenderData.scale * ( this.props.scale ?? 1 ) }
          fontWeight={ "bold" }
          style={ {
            fill: 'white',
            stroke: 'black',
            strokeThickness: 4,
          } }
        />
      </Container>

    );
  }
}

export default PixiGamePositionRibbon;
